import { Small } from '@/components/sv/typographies'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

export const OverviewFallback = () => (
  <div className="flex flex-col gap-3">
    <Skeleton className="h-3.5 w-70" />
    <Skeleton className="h-3.5 w-70" />
    <Separator />
    <Skeleton className="h-3.5 w-30" />
    <div className="flex items-center justify-between">
      <Small className="flex items-center gap-1">
        <Skeleton className="h-3.5 w-[90px]" />
      </Small>
      <Skeleton className="h-3.5 w-[80px]" />
    </div>
    <div className="flex items-center justify-between">
      <Small className="flex items-center gap-1">
        <Skeleton className="h-3.5 w-[60px]" />
      </Small>
      <Skeleton className="h-3.5 w-[110px]" />
    </div>
  </div>
)
